import Backbone from 'backbone'
import _ from 'underscore'
import TestViewTemplate from '../templates/test.tpl'
import ContentHeaderView from './content-header'
import Format from '../helpers/result-text-format'
import AnswerModel from '../models/answer'
import AnswerView from './answer'
import user from '../user'
import config from '../config'

const TestView = Backbone.View.extend({
    el: '#current-view',
    events: {
        'click .next-button' : 'nextQuestion',
        'click .hint-title' : 'showHint',
    },
    initialize() {
        this.template = _.template(TestViewTemplate)

        // reset the test model
        this.model.get('test').reset()

        // set the mode
        this.model.set('mode', 'test')

        // get 5 random questions
        const questions = this.model.get('question_list')
        const numQuestions = Math.min(5, questions.length)
        const randomQuestions = config.get('testMode') ? questions : _.sample(questions, numQuestions)

        // load them into the test model
        this.model.get('test').set({
            questions: randomQuestions,
            start_timestamp: new Date().getTime(),
        })

        // if this model changes it means the user has answered so show
        // the next question button AND explanation
        this.listenTo(this.model.get('test'), 'change', this.questionAnswered)
    },
    render() {
        const currentQuestion = this.model.get('test').currentQuestion()

        this.$el.html(this.template({
            color: this.model.get('color'),
            mode: 'test',
            count: this.model.get('test').get('count'),
            max_questions: this.model.get('test').get('questions').length,
            text: Format(currentQuestion.text),
            slug: config.get('slug'),
            image: currentQuestion.image,
            explanation: Format(currentQuestion.question_list[0].explanation),
            explanation_image: currentQuestion.question_list[0].explanation_image,
            explanation_2: Format(currentQuestion.question_list[0].explanation_2),
            explanation_image_2: currentQuestion.question_list[0].explanation_image_2,
            explanation_3: Format(currentQuestion.question_list[0].explanation_3),
            explanation_image_3: currentQuestion.question_list[0].explanation_image_3,
            explanation_4: Format(currentQuestion.question_list[0].explanation_4),
            hint: Format(currentQuestion.question_list[0].hint),
            hint_image: currentQuestion.question_list[0].hint_image
        }))

        const headerView = new ContentHeaderView({model: this.model})
        this.$('#header').append(headerView.render().el)

        _.each(_.shuffle(currentQuestion.question_list[0].answer_list), (answer) => {
            const answerModel = new AnswerModel(answer)
            const answerView = new AnswerView({model: answerModel, testModel: this.model.get('test')})
            this.$('.answers').append(answerView.render().$el)
        })

        return this
    },
    questionAnswered() {
        this.$('.explanation').show()
        this.$('.next').show()
    },
    showHint() {
        this.$('.hint').toggleClass('show-hint')
    },
    nextQuestion() {
        if (this.model.get('test').get('count') < this.model.get('test').get('questions').length) {
            this.render()
        } else {
            // set the end time
            this.model.get('test').set('end_timestamp', new Date().getTime())

            // get the image prefix
            const image_prefix = this.model.get('image_prefix')

            // this will award the user a star if they got 100% correct
            this.model.get('test').awardStar()

            // add the results to the results list
            user.get('results').add({
                user: user.get('uid'),
                app_title: config.get('id'),
                level: image_prefix,
                start_timestamp: this.model.get('test').get('start_timestamp'),
                end_timestamp: this.model.get('test').get('end_timestamp'),
                score: this.model.get('test').get('score'),
                total: this.model.get('test').get('count'),
                fluency_score: this.model.get('test').get('fluency_score'),
                fluency_total: this.model.get('test').get('fluency_count'),
                reasoning_score: this.model.get('test').get('reasoning_score'),
                reasoning_total: this.model.get('test').get('reasoning_count'),
                problem_score: this.model.get('test').get('problem_score'),
                problem_total: this.model.get('test').get('problem_count'),
                star: this.model.get('test').get('star'),
            })

            // navigate to the results screen
            const slug = config.get('slug')
            Backbone.history.navigate(`app/${slug}/test-result/${image_prefix}`, { trigger: true })
        }
    }
})

export default TestView
